<template>
  <header>
    <a href="/" class="logo">
      <img class="logo" alt="Inguo logo" src="@/assets/logo.png">
    </a>
    <nav aria-label="MainNav">
      <MainNav/>
    </nav>
    <nav class="user" v-if="isLoggedIn()" aria-label="UserNav">
      <UserNav/>
    </nav>
  </header>
</template>

<script>
import MainNav from '@/components/MainNav.vue'
import UserNav from '@/components/UserNav.vue'

export default {
  name: 'MainHeader',
  components: {
    MainNav,
    UserNav
  },
  methods: {
    isLoggedIn: function () {
      let user = localStorage.getItem('user')
      return user ? true : false
    }
  },
  watch: {
    $route () {
      this.isLoggedIn()
      this.$forceUpdate()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header {
  background-color: $primary;
  padding-left: 20px;
  display: flex;
  flex-shrink: 0;
  min-height: 50px;
  align-items: center;
  box-shadow: 0px -27px 15px 25px black;
  z-index: 10;
}

.logo {
  height: 32px;
  flex: 0 0 auto;
}

nav {
  color: #FFF;
  padding: 0 30px;
  flex: 2 0 auto;
}

nav.user {
  text-align: right;
  flex: 1 0 auto;
  padding-right: 0;
  height: 50px;
}
</style>
